// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const QuoteCloseSvg = ({ height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 28 23"
    role="presentation"
  >
    <path
      fill="#D0CDD0"
      fillRule="evenodd"
      d="M0 5.148c0-1.423.53-2.637 1.59-3.64C2.65.5 3.976 0 5.566 0c1.786 0 3.28.628 4.48 1.883 1.198 1.256 1.798 3.056 1.798 5.4 0 2.4-.362 4.56-1.088 6.487-.725 1.925-1.674 3.452-2.846 4.582-1.172 1.13-2.385 2.023-3.64 2.68-1.257.655-2.54 1.066-3.85 1.234v-4.018c1.84-.42 3.36-1.437 4.56-3.055 1.2-1.62 1.828-3.377 1.884-5.274-.42.278-.99.418-1.716.418-1.48 0-2.707-.468-3.683-1.402C.488 8 0 6.738 0 5.148zm16 0c0-1.423.53-2.637 1.59-3.64C18.65.5 19.976 0 21.566 0c1.786 0 3.28.628 4.48 1.883 1.198 1.256 1.798 3.056 1.798 5.4 0 2.4-.362 4.56-1.088 6.487-.725 1.925-1.674 3.452-2.846 4.582-1.172 1.13-2.385 2.023-3.64 2.68-1.257.655-2.54 1.066-3.85 1.234v-4.018c1.84-.42 3.36-1.437 4.56-3.055 1.2-1.62 1.828-3.377 1.884-5.274-.42.278-.99.418-1.716.418-1.48 0-2.707-.468-3.683-1.402C16.488 8 16 6.738 16 5.148z"
    />
  </svg>
);

QuoteCloseSvg.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default QuoteCloseSvg;
